export const config = {
    visionstrustUrl: process.env.REACT_APP_VISIONSTRUST_URL,
    logoBaseUrl: 'https://visionstrust.com/images/services',
    ImageRewardBaseUrl: process.env.REACT_APP_VISIONSTRUST_URL + '/images/uploads/rewards',
    ImageEventsBaseUrl: process.env.REACT_APP_VISIONSTRUST_URL + '/images/uploads/events',
    ssoUrl: process.env.REACT_APP_SSO_SERVER_URL,
};
